import React from "react";
import { Link } from "react-router-dom";
import formatUrl from "../../utils/formatedUrls";
import { PiFiles, PiFile } from "react-icons/pi";
import { FaCaretUp, FaCaretDown } from "react-icons/fa6";
import { Tooltip } from "@mantine/core";
import FormattedNumber from "../../utils/fixPrice";
import calculatePercentageChange from "../../utils/percentageMove";
import BigValueFormatter from "../../utils/bigNumbers";
import {
  EthTokenIcon,
  BscTokenIcon,
  SolTokenIcon,
  AvaxTokenIcon,
  PolygonTokenIcon,
  ArbitrumTokenIcon,
} from "../../utils/tokens/svgs";

const ProjectListItem = ({ p, index, currentPage, limit }) => {
  const projectId = p._id; // Assuming this is your _id
  const projectName = p.name; // Assuming this is your project name
  return (
    <div className="group contents [&:last-child>*]:border-b-0">
      <div className="flex h-full items-center border-b border-neutral-10 px-2 text-sm font-medium text-neutral-100 transition-colors first:pl-3 last:pr-3 group-hover:bg-neutral-5 dark:border-neutral-90 dark:text-neutral-0 dark:group-hover:bg-neutral-90 py-3 justify-start sticky z-10 left-0 bg-background-light dark:bg-background-dark bg-neutral-0 dark:bg-neutral-100">
        <div className="flex items-center justify-center">
          <button type="button" aria-label="Add to watchlist">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 256 256"
              className="text-neutral-50"
            >
              <rect width="256" height="256" fill="none"></rect>
              <path
                d="M132.4,190.7l50.4,32c6.5,4.1,14.5-2,12.6-9.5l-14.6-57.4a8.7,8.7,0,0,1,2.9-8.8l45.2-37.7c5.9-4.9,2.9-14.8-4.8-15.3l-59-3.8a8.3,8.3,0,0,1-7.3-5.4l-22-55.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7A8.2,8.2,0,0,1,132.4,190.7Z"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="16"
              ></path>
            </svg>
          </button>
        </div>
      </div>
      <div className="flex h-full items-center border-b border-neutral-10 px-2 text-sm font-medium text-neutral-100 transition-colors first:pl-3 last:pr-3 group-hover:bg-neutral-5 dark:border-neutral-90 dark:text-neutral-0 dark:group-hover:bg-neutral-90 py-3 justify-start sticky z-10 left-10 bg-background-light dark:bg-background-dark bg-neutral-0 dark:bg-neutral-100">
        <div className="flex items-center">
          {(currentPage - 1) * limit + index + 1}
        </div>
      </div>
      <div className="flex h-full items-center border-b border-neutral-10 px-2 text-sm font-medium text-neutral-100 transition-colors first:pl-3 last:pr-3 group-hover:bg-neutral-5 dark:border-neutral-90 dark:text-neutral-0 dark:group-hover:bg-neutral-90 py-3 justify-start sticky z-10 left-0 bg-n-0">
        <Link
          className="flex items-center gap-2 transition-opacity hover:opacity-75"
          to={`/projects/${formatUrl(p.network, p.name)}`}
          state={{ projectId: projectId }}
        >
          <div
            className="relative flex w-fit shrink-0 items-center justify-center overflow-hidden rounded-full"
            style={{ height: "28px", width: "28px" }}
          >
            <img
              alt={`${p.name} logo`}
              loading="lazy"
              width="28"
              height="28"
              decoding="async"
              data-nimg="1"
              className=""
              srcset={p.logo}
              style={{ color: "transparent" }}
            />
          </div>
          <div className="flex flex-col truncate text-sm gap-1">
            <div
              title={p.name}
              className="max-w-[6rem] truncate sm:max-w-[8rem]"
            >
              {projectName}
            </div>
            <div className="flex items-center">
              <div className="flex items-center gap-1 truncate rounded px-1 py-0.5 font-semibold capitalize bg-neutral-10 text-neutral-100 dark:bg-neutral-90 dark:text-neutral-0 text-2xs">
                {p.symbol}
              </div>
            </div>
          </div>
        </Link>
      </div>

      <div className="flex h-full items-center border-b border-neutral-10 px-2 text-sm font-medium text-neutral-100 transition-colors first:pl-3 last:pr-3 group-hover:bg-neutral-5 dark:border-neutral-90 dark:text-neutral-0 dark:group-hover:bg-neutral-90 py-3 justify-start bg-background-light dark:bg-background-dark bg-neutral-0 dark:bg-neutral-100">
        {p?.priceUsd === null ? (
          p?.presale ? (
            <span className="text-xs text-n-40">Presale</span>
          ) : p?.fairlaunch ? (
            <span className="text-xs text-n-40">Fair Launch</span>
          ) : (
            <span className="text-xs text-n-40">N/A</span>
          )
        ) : (
          <div className="flex flex-col truncate text-sm gap-0">
            <Tooltip
              label={`$${p?.priceUsd?.toFixed(24)}`}
              position="right"
              withArrow
            >
              <div className="cursor-pointer">
                <FormattedNumber number={p?.priceUsd?.toFixed(24)} />
              </div>
            </Tooltip>
            {p?.priceUsd24hAgo?.toFixed(24) === undefined ? (
              <span></span>
            ) : (
              <div
                className={`flex w-fit items-center rounded ${
                  p?.priceUsd?.toFixed(24) > p?.priceUsd24hAgo?.toFixed(24)
                    ? "text-success-main"
                    : "text-primary-main"
                } bg-transparent font-medium text-sm`}
              >
                {p?.priceUsd?.toFixed(24) > p?.priceUsd24hAgo?.toFixed(24) ? (
                  <FaCaretUp />
                ) : (
                  <FaCaretDown />
                )}
                {calculatePercentageChange(
                  p?.priceUsd?.toFixed(24),
                  p?.priceUsd24hAgo?.toFixed(24)
                )}
                %
              </div>
            )}
          </div>
        )}
      </div>

      <div className="flex h-full items-center border-b border-neutral-10 px-2 text-sm font-medium text-neutral-100 transition-colors first:pl-3 last:pr-3 group-hover:bg-neutral-5 dark:border-neutral-90 dark:text-neutral-0 dark:group-hover:bg-neutral-90 py-3 justify-start bg-background-light dark:bg-background-dark bg-neutral-0 dark:bg-neutral-100">
        <BigValueFormatter value={p?.marketCapUsd} />
      </div>
      <div className="flex h-full items-center border-b border-neutral-10 px-2 text-sm font-medium text-neutral-100 transition-colors first:pl-3 last:pr-3 group-hover:bg-neutral-5 dark:border-neutral-90 dark:text-neutral-0 dark:group-hover:bg-neutral-90 py-3 justify-start bg-background-light dark:bg-background-dark bg-neutral-0 dark:bg-neutral-100">
        <div className="flex items-center">
          <div className="flex items-center gap-[5px]">
            {p.network === 56 ? (
              <BscTokenIcon size={20} />
            ) : p.network === 1 ? (
              <EthTokenIcon size={20} />
            ) : p.network === 69 ? (
              <SolTokenIcon size={20} />
            ) : p.network === 43114 ? (
              <AvaxTokenIcon size={20} />
            ) : p.network === 137 ? (
              <PolygonTokenIcon size={20} />
            ) : p.network === 42161 ? (
              <ArbitrumTokenIcon size={20} />
            ) : null}
          </div>
        </div>
      </div>
      <div className="flex h-full items-center border-b border-neutral-10 px-2 text-sm font-medium text-neutral-100 transition-colors first:pl-3 last:pr-3 group-hover:bg-neutral-5 dark:border-neutral-90 dark:text-neutral-0 dark:group-hover:bg-neutral-90 py-3 justify-start bg-background-light dark:bg-background-dark bg-neutral-0 dark:bg-neutral-100 gap-2">
        <div
          className={`${
            p.score < 80 && p.score > 70
              ? "text-score-poor"
              : p.score < 70
              ? "text-score-alert"
              : "text-score-excellent"
          } flex w-10 justify-center rounded bg-current px-1 py-0.5 font-semibold`}
        >
          <div className="leading-3">
            <span className="text-xs text-neutral-0">{p.score}</span>
            <span className="text-2xs text-neutral-0">.00</span>
          </div>
        </div>
      </div>
      <div className="flex h-full items-center border-b border-neutral-10 px-2 text-sm font-medium text-neutral-100 transition-colors first:pl-3 last:pr-3 group-hover:bg-neutral-5 dark:border-neutral-90 dark:text-neutral-0 dark:group-hover:bg-neutral-90 py-3 justify-start bg-background-light dark:bg-background-dark bg-neutral-0 dark:bg-neutral-100">
        <div className="flex items-center">
          <div className="flex w-fit items-center gap-1.5">
            <div className="relative flex h-4 w-4 items-center justify-center rounded-[0.25rem] text-2xs font-semibold bg-success-surface text-success-main dark:bg-score-excellent-dark-background">
              {p.audits}
            </div>
            {p.audits > 1 ? (
              <PiFiles style={{ color: "#258c67" }} className="text-lg" />
            ) : (
              <PiFile style={{ color: "#258c67" }} className="text-lg" />
            )}
          </div>
        </div>
      </div>
      <div
        className={`flex h-full items-center border-b border-neutral-10 px-2 text-sm font-medium text-neutral-100 transition-colors first:pl-3 last:pr-3 group-hover:bg-neutral-5 dark:border-neutral-90 dark:text-neutral-0 dark:group-hover:bg-neutral-90 py-3 justify-start bg-background-light text-score-good-background dark:bg-background-dark bg-neutral-0 dark:bg-neutral-100`}
      >
        {p.kyc ? (
          <span className="rounded bg-score-good px-1 py-0.5 text-xs text-white">
            KYC
          </span>
        ) : (
          <span className="rounded bg-n-10 px-1 py-0.5 text-2xs text-n-50">
            No KYC
          </span>
        )}
      </div>
      <div className="flex h-full items-center border-b border-neutral-10 px-2 text-sm font-medium text-neutral-100 transition-colors first:pl-3 last:pr-3 group-hover:bg-neutral-5 dark:border-neutral-90 dark:text-neutral-0 dark:group-hover:bg-neutral-90 py-3 justify-start bg-background-light dark:bg-background-dark bg-neutral-0 dark:bg-neutral-100">
        {p?.trades24h !== null ? (
          p.trades24h
        ) : (
          <span className="text-xs text-n-40">N/A</span>
        )}
      </div>
      <div className="flex h-full items-center border-b border-neutral-10 px-2 text-sm font-medium text-neutral-100 transition-colors first:pl-3 last:pr-3 group-hover:bg-neutral-5 dark:border-neutral-90 dark:text-neutral-0 dark:group-hover:bg-neutral-90 py-3 justify-start bg-background-light dark:bg-background-dark bg-neutral-0 dark:bg-neutral-100">
        {p.date}
      </div>
    </div>
  );
};

export default ProjectListItem;
